import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { MessageService } from "primeng/components/common/messageservice";
import * as _ from 'lodash';

import { PaginationComponent } from '../../pagination/pagination.component';
import { PaginationService } from '../../../core/pagination/paginator.service';
import { AuthService } from "../../../core/auth/auth.service";
import { OpenPayService } from "../../../core/openpay/openpay.service";
import { CustomValidators } from "../../../core/validators/custom-validators";
import {ElectronicTransferModel, MemberWalletModel} from "../../../core/transfers/member-wallet.model";
import {UrlsResources} from "../../../core/urls-resources";
import {TransferService} from "../../../core/transfers/transfers.service";

@Component({
  selector: 'app-transfer-wallet-account',
  templateUrl: 'wallet-account.component.html',
  styleUrls: ['wallet-account.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class WalletAccountComponent extends PaginationComponent implements OnInit, AfterViewInit {

  searchForm: FormGroup;
  itemsSelected: MemberWalletModel[] = [];
  actualPage: number = 0;
  totalAmount: number = 0;

  private readonly ALL_MEMBERS_PATH: string = '/members/wallets';

  constructor (
    private urlsResources: UrlsResources,
    private paginationService: PaginationService,
    private authService: AuthService,
    private openpay: OpenPayService,
    private messageService: MessageService,
    private transferService: TransferService,
    private formBuilder: FormBuilder) {
    super (messageService, paginationService);
  }

  ngAfterViewInit() {
  }

  ngOnInit() {

    this.buildForm();
    this.data = { endPoint: this.urlsResources.getPrivateRoot(), page: 0, size: 15, path: this.ALL_MEMBERS_PATH };
    this.getUserInfoFromService();
    super.ngOnInit();

  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      email: ['', [CustomValidators.email]]
    });
  }

  searchByEmail(): void {
    this.data.path = `/member/wallet/${this.searchForm.value.email}`;
    this.getPaginationData();
  }

  reload(): void {
    this.searchForm.reset();

    this.data.path = this.ALL_MEMBERS_PATH;
    this.getPaginationData();
  }

  paginate(event) {
    this.data.size = event.rows;
    this.actualPage = event.page;
    this.getPage(this.actualPage);
  }

  processContent(content: any[]) {

    this.itemsSelected.forEach( item => {
      let found = content.find(contentItem => contentItem.walletCustomerId === item.walletCustomerId);
      if (found) {
        found.amount = item.amount;
      }
    });
    return content;

  }

  doElectronicTransferToUsers() {

    this.loading = true;
    this.transferService.doElectronicTransferToUsers(this.fillModel()).finally(() => {
        this.itemsSelected = [];
        this.getPage(this.actualPage);
      })
      .subscribe(response => {
        this.totalAmount = 0;
        this.getUserInfoFromService();
        console.log('mostramos la respuesta: ', response);
        this.messageService.add({
            severity: 'success',
            summary: '',
            detail: 'Se realizo la peticion con exito'
          });
      },
      error => {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error
          });
      })

  }

  private getUserInfoFromService(){
    this.authService.getCustomerByUsername()
      .subscribe(response => {
          console.log('Mostramos la informacion del usuario',response);
        },
        err => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err
          });
        });
  }

  private fillModel(): ElectronicTransferModel {
    let model: ElectronicTransferModel = new ElectronicTransferModel();
    model.deviceSessionId = this.openpay.deviceSessionId;
    model.listOfCustomers = this.itemsSelected;
    return model;
  }

  addReference(value) {

    _.remove(this.itemsSelected, item => item.walletCustomerId === value.data.walletCustomerId);
    let amount = parseFloat(value.data.amount);
    this.itemsSelected = _.concat(this.itemsSelected, value.data);
    this.getTotales();

    // trucazo para que el elemento sea deseleccionado
    // si se borraba antes de getTotales, el datatable mantenia seleccionado el elemento
    if (amount === 0 || _.isNaN(amount)) {
      _.remove(this.itemsSelected, item => item.walletCustomerId === value.data.walletCustomerId);
    }

  }

  getTotales() {

    this.totalAmount = 0;
    _.forEach(this.itemsSelected, item => {

      let amount = parseFloat(item.amount);
      if (!_.isNaN(amount)) {
        this.totalAmount += amount;
      }

    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/transfers/wallet-account/wallet-account.component.ts